import { render, staticRenderFns } from "./ContactsRoot.vue?vue&type=template&id=326001b8&"
import script from "./ContactsRoot.vue?vue&type=script&lang=js&"
export * from "./ContactsRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports